export default __webpack_public_path__ + "static/carousel-bg-e6b4c761126bca74336a82621501c59d.png";